module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.destinations), function(destination) {
    return _c('li', [_c('div', {
      on: {
        "click": function($event) {
          _vm.setDestination(destination)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": destination.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(destination.name))])])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("...or suggest a new destination.")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "placeholder": "Destination"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Suggest")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb1f70c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Destinations.vue
// module id = 68
// module chunks = 1